<template>
  <div style="padding: 0 10px;">
    <div style="text-align: center;" class="ft14">隐私政策</div>
    <div class="ft15">生效日期：2022年【11】月【14】日</div>
    <div class="ft15">版本号：【v1.0】</div>
    <div class="ft14">欢迎使用由厦门亲禾教育科技有限公司（以下简称“亲禾”“本公司”或“我们”）提供的“亲小禾”产品服务。我们法定注册地址为：厦门市软件园二期望海路63号之二302单元50。</div>
    <div class="ft14">我们非常重视您（以下或称“用户”）的隐私权，深知个人信息对您的重要性，并采取相应保护措施，致力于保护您的个人信息安全可控，特按照相关法律法规要求制定本隐私政策（以下简称“本政策”)本政策适用于所有亲禾旗下产品服务，包括但不限于：亲禾官网（https://www.xiaohebook.com）及亲小禾用户端（以下简称“亲小禾产品服务”)。在特定情况下，我们可能通过弹窗等方式获取您的单独同意，弹窗方案将构成本政策的有效组成部分。某些特定产品服务还将适用特定的个人信息保护政策，我们将在向您提供这些特定产品服务前进一步说明。如特定的个人信息保护政策与本政策有不一致之处，以特定的个人信息保护政策为准。特定的个人信息保护政策未提及之处，以本政策为准。</div>
    <div class="ft14">本政策旨在向您说明，在使用我们的产品服务时，我们如何收集、存储、使用、分享、管理和保护您的用户信息（包括个人信息）以及为您提供的访问、更新、控制和保护这些信息的方式。请务必仔细阅读并充分理解本政策，并在确认理解本政策的情况下做出选择。提醒请您特别关注：</div>
    <div class="ft14">1．使用<span class="ft13">加粗</span>与斜体相结合显著标识的内容，表示这些属于您的敏感个人信息或权限信息。</div>
    <div class="ft14">1．使用<span class="ft13">加粗</span>与<span class="ft12">下划线</span>相结合显著标识的内容，表示这些内容需要您特别关注或重点注意。</div>
    <div class="ft14">
      如您对本政策有任何问题，可以随时通过本政策第十一条所述方式联系我们，我们会在15个工作日内完成核查和处理。
      <span class="ft16">如果您是儿童，请在法定监护人陪同下仔细阅读并经监护人确认后决定是否接受本政策。如您不同意本政策、请立即停止使用亲禾旗下产品服务。</span>
    </div>
    <div class="ft16">本政策将帮助您了解以下内容：</div>
    <div class="ft16">一、如何收集和使用您的个人信息</div>
    <div class="ft16">二、如何共享、转让、公开披露您的个人信息</div>
    <div class="ft16">三、如何保存您的个人信息</div>
    <div class="ft16">⦁	如何保存和保护您的个人信息</div>
    <div class="ft16">⦁	如何使用Cookie</div>
    <div class="ft16">六、APP隐私惯例</div>
    <div class="ft16">七、您如何管理您的个人信息</div>
    <div class="ft16">⦁	未成年人保护</div>
    <div class="ft16">九、适用法律</div>
    <div class="ft16">十、本政策的更新</div>
    <div class="ft16">十一、如何联系我们</div>
    <div class="ft16">⦁	名词解释</div>
    <div class="ft16">一、如何收集和使用您的个人信息</div>
    <div class="ft14">在您使用我们的产品服务时，我们需要或可能需要收集和使用您的个人信息包括如下两种：</div>
    <div class="ft14">(1）为实现向您提供我们产品服务的基本业务功能，您须授权我们收集、使用必要的个人信息。如您拒绝提供相应信息，您将无法正常使用我们的产品服务；</div>
    <div class="ft14">(2）为实现向您提供我们产品服务的扩展业务功能，您可选择授权我们收集、使用的个人信息。如您拒绝提供，您将无法正常使用相关扩展业务功能或无法达到我们拟达到的功能效果，但并不会影响您正常使用我们产品服务的基本业务功能。</div>
    <div class="ft14">亲禾产品服务的基本业务功能为识别绘本，并播放音频，此功能下的必要个人信息为：您的移动电话号码、您孩子的身份信息（包括姓名、出生日期和性别）。</div>
    <div class="ft16">1. 注册账号</div>
    <div class="ft14">如果您使用我们的产品服务时，需要注册或登录亲小禾，我们将根据您注册的方式，收集以下个人信息：</div>
    <div class="ft14"><span class="ft13">在您进行注册／登录时，您需要向我们提供手机号码，</span>以识别您的身份。同时我们将通过发送短信的方式告知并进行验证。您可根据收到的短信验证码进行登录使用我们产品服务。</div>
    <div class="ft14">如果您不提供这些信息，则您将无法注册／登录亲禾教育产品服务，无法正常使用亲小禾的所有相关功能。</div>
    <div class="ft16">2．绘本阅读</div>
    <div class="ft14">当您需要听绘本的音频时，将绘本放入识别框内，我们即可获取您的绘本信息，并自动播放绘本内容。在您同意开启相机权限后，我们会识别您的绘本信息。除实现本政策所述的亲小禾软件服务目的外我们不会将这些信息用于其他商业目的或共享给第三方。</div>
    <div class="ft16">3. 个性化推荐</div>
    <div class="ft14">当您使用我们的产品服务时，为向您展示更符合您偏好的内容，我们将会根据您的绘本阅读记录给你推送相类似的绘本；若您不希望接收定向推送的信息，您可以直接点击右上角图标进入【设置】页面，选择【个性推荐】开关进行关闭。</div>
    <div class="ft16">4．收集其他信息</div>
    <div class="ft14">当您使用我们的产品服务时，需要获取您以下信息，以便实现对应的功能：
      获取<span class="ft13">已安装APP信息，</span>用于角标未读消息功能；
      获取<span class="ft13">运行中进程信息，</span>用于判断应用所处状态，控制音视频的播放或暂停；
      获取Android_ID，用于生成设备唯一ID；</div>
    <div class="ft16">5．安全防护与异常排查</div>
    <div class="ft14">
      在您使用我们服务过程中，为了满足法律法规及提供服务的基本要求、了解产品适配性、向您提供更契合您需求的页面展示和搜索结果、保障您的账号安全与系统运行安全，判断您的账号风险、更准确地预防钓鱼网站、仿冒App等欺诈风险，保障我们为您正常提供服务，排查异常信息，我们会收集您在使用亲小禾产品服务及软件过程中产生的相关信息并存储为网络日志信息，这些信息包括：
      <br>设备信息：当您在移动设备上使用我们的产品服务时，我们将会根据你在软件安装及使用中授予的具体权限，收集与您的设备相关的信息。包括：
      <span class="ft13">设备型号、操作系统版本、设备设置、设备标识符、MAC（媒体访问控制）地址、IMEl（移动设备国际身份码）、设备所在位置相关信息（如IP地址、GPS位置以及能够提供相关信息的Wi-Fi接入点、蓝牙和基站等传感器信息），</span>
      方便我们统计使用我们产品服务的设备数量并进行设备机型数据分析与设备适配性分析。另外设备信息还将作为我们识别真实用户而不是外挂软件、机器的重要依据。
    </div>
    <div class="ft14"><span class="ft13">网络信息：</span>当您在连网状态下使用我们的产品服务时，我们收集您所使用的网络类型，目的是为了解您使用服务的用户场景。</div>
    <div class="ft14">
      <span class="ft13">日志信息：</span>
      当您使用我们的产品服务时，我们将会自动收集您对我们的产品服务的详细使用情况，作为日志信息保存。这些信息包括：(1)关于您的
      <span class="ft13">使用时间与使用频率</span>的细节；(2）<span class="ft13">设备统计信息、关键操作路径、错误日志、崩溃记录、语言和时区；</span>(3）
      <span class="ft13">互联网协议(IP)地址、浏览器类型、互联网服务供应商（ISP)、引用／退出页面、操作系统、日期／时间戳和点击流数据。</span>
      这些日志信息能够帮助我们更好的了解和改善我们的服务，并非用于识别任何特定的个人。
    </div>
    <div class="ft14">
      <span class="ft13">元数据：</span>
      元数据通常是与用户内容相关联的技术数据，简而言之，它是描述数据的数据。例如，它可以描述图片（或同类文件）中包含的粗略人物特征和图片中包含的内容。正常情况下，这些元数据无法用于识别任何特定的个人。这些元数据是为了改进服务目的，并非用于识别任何特定的个人。
    </div>
    <div class="ft16">6．意见反馈</div>
    <div class="ft14">当您购买商品或服务后在本平台进行留言反馈或评价时，为了跟进您的反馈，我们可能会使用您所提供的个人信息（包括姓名、手机号码）与您联系，并保留记录。在一些情况下，即使您从我们的产品服务中删除了反馈信息，该信息仍然可能会留存在与我们没有关联及不受我们控制的第三方独立地缓存、复制或存储，或通过其他用户或该等第三方在公众可获知的领域保存。如其中含有个人信息，将给您带来一定风险。因此，建议您在留言和评论中谨慎考虑。</div>
    <div class="ft16">（一）亲小禾产品／或服务设备调用说明</div>
    <div class="ft14">下列情形中，您可选择是否授权我们采集、使用您的个人信息。使用下列功能可能需要您在您的设备中开启您的相机（摄像头），我们将在您开启的访问权限范围内收集、使用您的个人信息。但我们会将征求您同意的频率控制在48小时一次，不干扰您的正常使用。</div>
    <div class="ft14">请您注意，您开启任一权限即代表您授权我们可以收集和使用相关个人信息来为您提供对应服务，您一旦关闭任一权限即代表您取消了授权，我们将不再基于对应权限继续收集和使用相关个人信息，也无法为您提供该权限所对应的服务。但是，您关闭权限的决定不会影响此前基于您的授权所进行的信息采集与使用。</div>
    <div class="ft14">如在下列情形之外收集或使用您的个人信息，我们会事先另行获得您的授权，并向您充分告知收集和使用您个人信息的目的、方式和范围。该告知内容也构成本政策的一部分。</div>
    <div class="ft14">
      <span class="ft13">1．相机权限或相册权限（iOS系统）：</span>
      用于更换头像、昵称、绘本识别等服务，若您不开启此权限，您将无法使用完善账号信息、绘本识别等相关的功能，但不影响您使用其他服务。
    </div>
    <div class="ft14">
      <span class="ft13">2．存储权限（Android系统）：</span>
      用于更换头像、昵称等服务，若您不开启此权限，您将无法使用完善账号信息等相关的功能，但不影响您使用其他服务。
    </div>
    <div class="ft14">
      <span class="ft13">3．获取任务信息权限：</span>
      获取当前运行进程ID和名称，用于判断是否是我们APP的进程启动了，一边进行相应的初始化，保证APP的正常运行。
    </div>
    <div class="ft14">
      <span class="ft13">4．读取电话状态：</span>
      获取IMEI/IMSI，用于生成我们系统的唯一设备ID，保障账号登录安全和统计数据的准确。
    </div>
    <div class="ft16">（二）其他合法性基础</div>
    <div class="ft14">根据相关法律法规及国家标准，以下情形中，我们在未经征求您的同意时可能会收集、使用您的个人信息：</div>
    <div class="ft14">1．为订立、履行个人作为一方当事人的合同所必需</div>
    <div class="ft14">2．为履行法定职责或者法定义务所必需；</div>
    <div class="ft14">3. 为应对突发公共卫生事件，或者紧急情况下为保护自然人的生命健康和财产安全所必需；</div>
    <div class="ft14">4. 依照《个人信息保护法》的规定在合理的范围内处理个人自行公开或者其他已经合法公开的个人信息；</div>
    <div class="ft14">5. 法律、行政法规规定的其他情形。</div>
    <div class="ft14">
      请知悉，根据适用的法律，若我们
      <span class="ft13">对个人信息采取技术措施和其他必要措施进行处理，使得数据接收方无法重新识别特定个人且不能复原，</span>
      或我们可能会对收集的信息进行去标识化处理后进行研究、测试、统计分析和预测，用于改善本平台的内容和布局，为商业决策提供产品或服务支撑，以及改进我们的产品服务，
      <span class="ft13">则此类处理后数据的使用无需另行向您通知并征得您的同意。</span>
    </div>
    <div class="ft16">二、如何共享、转让、公开披露您的个人信息</div>
    <div class="ft16">（一）共享您的个人信息</div>
    <div class="ft14">除我们主动收集的个人信息，您通过亲小禾识别绘本的信息，我们仅作为数据存储于服务器，按照《网络安全法》《个人信息保护法》及其他法律法规、监管政策要求，我们不会将您的此类信息进行收集用于其他商业目的或信息分享，但当符合国家相关法律法规及其政策要求或国家相关部门的要求时，我们会在法律允许的范围内使用您的此类信息，例如检索、筛选您的此类信息中是否存在不符合法律、法规、违反公序良俗等情形的内容，并向国家相关部门提交涉嫌违反相关法律法规规定的信息。</div>
    <div class="ft14">我们不会向其他个人信息处理者提供您的个人信息。在如下情况下，当我们将向第三方个人信息处理者提供您的个人信息，会以【弹窗等】方式向您告知在单个场景下涉及到的接收方的名称或者姓名、联系方式、处理目的、处理方式和个人信息的种类，并取得您的单独同意。目前，我们的授权合作伙伴主要包括以下类型：</div>
    <div class="ft14">
      登录的授权合作伙伴：可能将访问您的
      <span class="ft13">手机号码、设备识别信息（包括IMS、和IP地址），但不会采集您的其他个人身份信息。</span>
      此类信息是为了用于帮助用户快速登录使用APP，减少因为账号密码问题影响使用。
    </div>
    <div class="ft16">（三）转让</div>
    <div class="ft14">原则上我们不会将您的个人信息控制权向其他公司、组织或个人进行转移。如因合并、分立、解散、被宣告破产等原因确需转移，我们将向您告知接收方的名称或者姓名和联系方式，并要求接收方继续履行个人信息处理者的义务。接收方变更原先的处理目的、处理方式的，我们将要求其依照法律规定重新取得您的同意。</div>
    <div class="ft16">（四）公开披露</div>
    <div class="ft14">我们不会公开我们所处理的您的个人信息，除非取得您的单独同意。</div>
    <div class="ft16">三、如何保存您的个人信息</div>
    <div class="ft16">⦁	保存地域</div>
    <div class="ft14">我们依照法律法规的规定，将您的个人信息存储于中华人民共和国境内，目前，我们不会将上述信息传输至境外。</div>
    <div class="ft16">（二）保存期限</div>
    <div class="ft14">我们承诺您个人信息的存储时间始终处于合理必要期限内。我们只会在达成本政策所述目的所需的最短期限内保留您的个人信息，除非法律有强制的留存要求，例如：《电子商务法》要求商品和服务信息、交易信息保存时间自交易完成之日起不少于三年；</div>
    <div class="ft14">《网络安全法》要求采取监测、记录网络运行状态、网络安全事件的技术措施，并按照规定留存相关的网络日志不少于六个月。我们判断前述期限的标准包活：</div>
    <div class="ft14">1．完成与您交易相关的目的、维护相应交易及业务记录、应对您可能得查询与投诉；</div>
    <div class="ft14">2. 保证我们为您提供服务的安全和质量；</div>
    <div class="ft14">3．您是否同意更长的留存期限；</div>
    <div class="ft14">4．是否存在保留期限内的其他特别约定。</div>
    <div class="ft14">在您的个人信息超出保留期间后，我们会根据适用法律的要求删除您的个人信息，或对其进行匿名化处理。</div>
    <div class="ft14">您在注销账号后，我们将删除您相应的个人信息，因相关法律法规要求需要保存一定期限的情况除外。</div>
    <div class="ft14">如我们因经营不善或其他原因出现停止运营的情况，我们会立即停止对您个人信息的收集，删除或匿名化已收集的个人信息。我们会将此情况以推送通知、公告等方式通知您。</div>
    <div class="ft16">四、我们如何保护您的个人信息</div>
    <div class="ft14">1．我们使用合理措施，以防信息的丢失、不当使用、未经授权阅览或披露。对我们的网站提供HTTPS安全浏览方式；会使用加密技术、并不断更新密钥来确保数据的保密性，并使用受信赖的保护机制防止数据遭到恶意攻击；以及定期进行信息安全能力评估／信息安全风险评估，定期进行数据库的容灾备份，确保安全保护系统始终处于完备状态；不断提升技术手段以加强维护软件安全；建立信息保护管理制度等。但请您理解（在互联网行业）即便竭尽所能加强安全措施，也不可能始终保证信息百分之百的安全。您需要了解，您接入我们的服务所用的系统和通讯网络，有可能因我们可控范围外的因素而出现问题。</div>
    <div class="ft14">2．我们重视信息安全合规工作，定期进行IT审计，并与监管机构、第三方测评机构建立了良好的协调沟通机制，以抵御并处置各类信息安全威胁，为您的信息安全提供全方位保障。</div>
    <div class="ft14">3．在不幸发生个人信息安全事件后，我们将按照法律法规的要求，及时向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。我们将及时将事件相关情况以电话、推送通知等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，主动上报个人信息安全事件的处置情况。</div>
    <div class="ft16">五、如何使用Cookie</div>
    <div class="ft14">在您使用我们的产品服务过程中，我们会使用cookie自动收集您的信息，并将该信息储存为日志信息。我们会在您的计算机或移动设备上发送一个或多个名为Cookies的小数据文件，指定给您的Cookies是唯一的，它只能被将Cookies发布给您的域中的Web服务器读取。我们向您发送Cookies是为简化您重复登录的步骤、存储您的偏好设置、帮助您优化对广告的选择与互动、帮助判断您的登录状态以及账号或数据安全，帮助分析和改善产品服务和提升产品体验。</div>
    <div class="ft14">我们不会将Cookies用于本隐私政策所述目的之外的任何用途。您可根据自己的偏好管理或删除Cookies。您可以清除计算机上保存的所有Cookies，大部分网络浏览器会自动接受Cookies,但您通常可根据自己的需要来修改浏览器的设置以拒绝Cookies;另外，您也可以清除软件内保存的所有Cookies。但如果您这么做，您可能需要在每次使用亲禾教育产品服务时亲自更改用户设置，而且您之前所记录的相应信息也均会被删除，并且可能会对您所使用服务的安全性有一定影响。</div>
    <div class="ft16">六、APP隐私惯例</div>
    <div class="ft16">为便于您清楚了解到使用亲小禾APP时我们或我们的授权合作伙伴可能向您收集的数据类型以及具体处理方式，我们重申或补充以下隐私惯例，请您在确保知悉并同意的前提下下载并使用亲小禾APP:</div>
    <div class="ft14">（一）亲小禾APP收集的数据类型主要包括：姓名、电话号码、联系人、用户ID、设备ID、产品交互、崩溃数据、性能数据。</div>
    <div class="ft14">（二）姓名、电话号码、联系人等，将用于APP功能以及与用户身份关联；用户ID将用于APP功能、分析以及与用户身份关联；设备ID将用于APP功能、分析以及与用户身份关联；产品交互将用于APP功能、分析以及与用户身份关联；性能数据将用于分析、APP功能。</div>
    <div class="ft16">七、您如何管理您的个人信息</div>
    <div class="ft14">您可以通过以下方访问及管理您的信息：</div>
    <div class="ft16">⦁	查询、更正和补充您的信息</div>
    <div class="ft14">您有权查询、更正或补充您的信息。您可以通过以下方式自行进行：</div>
    <div class="ft14">1．进入“设置﹣账号管理”对个人资料信息进行查询、更正或补充；</div>
    <div class="ft14">2．如果您希望查询、更正、补充您的其他个人信息，可根据本政策第9条所述方式联系我们，我们会在15个工作日内完成核查和处理。我们将会在收到您的电子邮件或者信函后的合理时间内处理您的请求，并且会根据您的请求，在此之后不再收集、使用、披露您的个人信息。请注意，您撤销同意或者删除您的个人信息后，可能会影响您使用某些我们的服务。</div>
    <div class="ft16">（二）删除您的信息</div>
    <div class="ft14">在以下情形中，我们将主动删除您的个人信息。如我们未删除的，您有权根据本政策第9条所述方式联系我们请求删除：</div>
    <div class="ft14">1．处理目的已实现、无法实现或者为实现处理目的不再必要；</div>
    <div class="ft14">2．我们停止提供产品服务，或者保存期限已届满；</div>
    <div class="ft14">3．您撤回同意</div>
    <div class="ft14">4. 我们违反法律、行政法规或者违反约定处理个人信息；</div>
    <div class="ft14">5．法律、行政法规规定的其他情形。</div>
    <div class="ft14">您可以通过“（一）查询、更正和补充您的信息”中列明的方式删除您的部分信息。</div>
    <div class="ft14">若我们决定响应您的删除请求，我们还将同时尽可能通知从我们处获得您的个人信息的主体，并要求其及时删除（除非法律法规另有规定，或这些主体已独立获得您的授权）。</div>
    <div class="ft14">当您或我们协助您删除相关信息后，因为适用的法律和安全技术，我们可能无法立即从备份系统中删除相应的信息，我们将安全地存储您的个人信息并将其与任何进一步处理隔离，直到备份可以清除或实现匿名。</div>
    <div class="ft16">（三）撤回已同意的授权</div>
    <div class="ft14">1．针对“一、我们如何收集您的信息”中各项功能涉及的硬件调用、个人信息访问权限，您可以通过Android或iOS系统设置的权限设置功能操作取消授权。 请注意，您撤回已同意的授权后，可能会影响您使用某些我们的服务。具体如下：</div>
    <div class="ft14">(1)	如果您撤回<span class="ft13">相机权限，</span>您将无法在修改个人信息时无法更换头像；无法使用绘本识别比较功能；</div>
    <div class="ft14">(2）如果您撤回<span class="ft13">相册权限（iOS系统），</span>您将无法在修改个人信息时无法更换头像；</div>
    <div class="ft14">(3）如果您撤回<span class="ft13">存储权限（Android系统），</span>您将无法在修改个人信息时无法更换头像；</div>
    <div class="ft14">2．当您想撤销对第三方账号（如微信）的授权并解除绑定时，绑定解除路径为【设置﹣徹回隐私政策授权】，您也可以通过路径进行绑定，便于您快速安全登录。</div>
    <div class="ft14">3．当您想撤回对隐私政策的同意时，撤回路径为【设置﹣撤回隐私政策授权】。在您撤回对隐私政策同意之后，我们将停止为您提供产品服务，根据适用法律的要求删除您的个人信息，或使其匿名化处理。</div>
    <div class="ft16">（四）注销您的账号</div>
    <div class="ft14">您可以通过“设置﹣注销账号”提交账号注销申请，在您主动注销账号之后，我们将停止为您提供产品服务，根据适用法律的要求删除您的个人信息，或使其匿名化处理。提醒您注意，您注销账号的行为是不可逆的，一旦您的账号被注销，我们将不再收集您的个人信息，也不再为您提供产品服务；该账号在使用期间已产生但未使用完毕的所有资产和权益将被清除，该账号下的内容、信息等将会被删除或匿名化处理，除非法律法规另有规定或监管部门另有要求。此我们建议您谨慎选择注销账号。</div>
    <div class="ft16">（五）获取个人信息副本</div>
    <div class="ft14">您有权根据法律法规或国家标准的规定，您有权查阅、复制您的个人信息，您可以发送电子邮件到【xiamenqinheeducation@xiaohebook.com】联系我们，我们会在15个工作日内完成核查和处理。如您请求将您的个人信息转移至您指定的个人信息处理者，符合国家网信部门规定条件的，我们将提供转移的途径。</div>
    <div class="ft16">⦁	个性化展示／推送</div>
    <div class="ft14">如果您不想收到通过算法自动决策后的个性化展示，您可以在“设置﹣个性化展示”中退订或者发送电子邮件到【xiamenqinheeducation@xiaohebook.com】联系我们，我们会在15个工作日内完成核查和处理。您拒绝接受推送服务之后，我们将把为达成个性化推送而收集的您的个人信息做删除或匿名化处理，并且向您提供业务功能时，不再基于您的个人信息做推送。</div>
    <div class="ft16">（七）响应您的上述请求</div>
    <div class="ft14">为保障您的账号安全，我们可能会先要求您验证自己的身份（如要求您提供书面请求或其他方式）,然后再处理您的请求。对于您的请求，我们将于收到您的请求后的15个工作日内完成核查和处理。需注意的是，我们可能不会回复与本政策或与个人信息保护无关的问题。</div>
    <div class="ft14">对于您合理的请求，我们原则上不收取费用。但对多次重复、超出合理限度的请求，我们将视情况收取一定的成本费用。对于那些与法律法规要求相悖、无端重复、需要过多技术手段（比如需要开发新系统或者从根本上改变现行惯例）、给他人合法权益带来风险或者非常不切实际的请求，我们可能会予以拒绝。</div>
    <div class="ft14">如您对自身作为数据主体权利有进一步要求或存在任何疑问、意见或建议，可通过本政策第9条所述方式联系我们，我们会在15个工作日内完成核查和处理。</div>
    <div class="ft16">八、未成年人保护</div>
    <div class="ft14">我们的产品服务主要面向成人。如果没有父母及其他监护人的同意，儿童即未满14周岁的未成年人）不得创建自己的用户账号。</div>
    <div class="ft14">对于经父母及其他监护人同意而收集儿童个人信息的情况，我们只会在受到法律允许、父母及其他监护人明确同意或者保护儿童所必要的情况下使用或公开披露此信息。关于我们如何收集和处理儿童个人信息，请您详见《儿童隐私协议》。</div>
    <div class="ft16">九、适用法律</div>
    <div class="ft14">本政策，包括但不限于本政策的订立、效力、解释、履行和争议解决，均应适用中华人民共和国法律（不包括香港特别行政区与澳门特别行政区法律）。</div>
    <div class="ft16">十、本政策的更新</div>
    <div class="ft14">您理解并同意：我们根据法律法规或者我们的商业决策相应更新本政策，您愿意受修订后政策的约束。如果涉及本政策重大变更，我们将以公告或者信息推送方式做出。</div>
    <div class="ft14">本政策所指的重大变更包括但不限于：</div>
    <div class="ft14">1、我们的产品服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等；</div>
    <div class="ft14">2、我们在所有权结构、组织架构等方面发生重大变化。如业务调整、破产并购等引起的所有者变更等；</div>
    <div class="ft14">3、个人信息共享、转让或公开披露的主要对象发生变化；</div>
    <div class="ft14">4、您参与个人信息处理方面的权利及其行使方式发生重大变化</div>
    <div class="ft14">5、我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化时；</div>
    <div class="ft14">6、个人信息安全影响评估报告表明存在高风险时。</div>
    <div class="ft14">我们还会将本政策的旧版本存档，供您查阅。</div>
    <div class="ft14">为给您带来更好的产品服务体验，我们在持续努力改进我们的技术，随之我们可能会不时推出新的或优化后的功能，可能需要收集、使用新的个人信息或变更个人信息使用目的或方式。对此，我们更新本政策，并将通过弹窗、页面提示方式另行向您说明对应信息的收集目的、范围及使用方式，并为您提供自主选择同意的方式，且在征得您明示同意后收集、使用。在此过程中，如果您有任何疑问、意见或建议的，您可通过本政策第9条所述方式联系我们，我们会在15个工作日内完成核查和处理。</div>
    <div class="ft16">十一、如何联系我们</div>
    <div class="ft14">如您对本政策内容有任何疑问，请通过以下方式 与我们联系：(1)电子邮箱：xiamenqinheeducation@xiaohebook.com; (2）邮寄方式：福建省厦门市集美区软件园三期B区19栋22楼（361001）;(3）电话：18046218090。我们的个人信息保护专员会在收到您的联系信息后的15个工作日内完成核查和处理。</div>
    <div class="ft14">如您对我们的回复不满意或者是您认为我们对个人信息或用户信息的处理行为损害了您的合法权益，你还可以向履行个人信息保护职责的部门进行投诉、举报。</div>
    <div class="ft16">十二、名词解释</div>
    <div class="ft14">本政策中使用到的名词，在通常意义中有如下定义：</div>
    <div class="ft14">1．<span class="ft13">个人信息：</span>以电子或者其他方式记录的与已识别或者可识别的自然人有关的各种信息，，包括但不限于自然人的姓名、出生日期、身份证件号码、个人生物识别信息、住址、电话号码等，不包括匿名化处理后的信息。</div>
    <div class="ft14">2．<span class="ft13">敏感个人信息：</span>一旦泄露或者非法使用，容易导致自然人的人格尊严受到侵害或者人身、财产安全受到危害的个人信息，包括生物识别、宗教信仰、特定身份、医疗健康、金融账号、行踪轨迹等信息，以及不满十四周岁未成年人的个人信息，例如，个人敏感信息包括身份证件号码、个人生物识别信息、银行账号、通信内容、健康生理信息等。</div>
    <div class="ft14">3．<span class="ft13">去标识化：</span>个人信息经过处理，使其在不借助额外信息的情况下无法识别特定自然人的过程。</div>
    <div class="ft14">4．<span class="ft13">匿名化：</span>个人信息经过处理无法识别特定自然人且不能复原的过程。</div>
    <div class="ft14">5．<span class="ft13">IMEl（移动设备国际身码）：</span>InternationalMobileEquipmentldentity，即通常所说的手机序列号、手机“串号”，用于在移动电话网络中识别每一部独立的手机等移动通信设备，相当于移动电话的身份证。在大部分终端设备中都可以通过拨号输入*#06＃来查询；</div>
    <div class="ft14">6．<span class="ft13">MAC（媒体访问控制）地址：</span>MAC(MediaAccessControl或者MediumAccessControl）地址，意译为媒体访问控制，或称为物理地址、硬件地址，用来定义网络设备的位置。在OSI模型中，第三层网络层负责IP地址，第二层数据链路层则负责MAC地址。因此一个主机会有一个MAC地址，而每个网络位置会有一个专属于它的IP地址，MAC地址是网卡决定的，是固定的；</div>
    <div class="ft14">7．<span class="ft13">Cookie：</span>Cookie是载有一连串文字的小型档案，在您登入网站或其他网络内容时存放在您的计算机、流动电话或其他装置内。</div>
  </div>
</template>

<script>
export default {
  name: "AgreementPrivacy"
}
</script>

<style scoped>
.ft12{
  text-decoration: underline;
}

.ft13{
  font-weight: 700;
}

.ft14{
  font-size: 14px;
  margin-bottom: 10px;
}

.ft15{
  text-align: right;
  font-size: 14px;
  margin: 0 10px 10px 0;
}

.ft16 {
  font-size: 14px;
  font-weight: 700;
  margin-bottom: 10px;
}
</style>
